import React from 'react';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useAccount } from 'Account/hooks/account';
import {
  isBillingAddressComplete,
  isTaxInformationComplete,
} from 'ShorePay/utils';

const OrderReader = () => {
  const accQuery = useAccount();
  const hasValidAddress =
    accQuery.isSuccess &&
    isBillingAddressComplete(accQuery.data.billing_address) &&
    isTaxInformationComplete({
      tax_number: accQuery.data.tax_number,
      vat_number: accQuery.data.vat_number,
    });

  return (
    <Button type="dashed" block disabled={!hasValidAddress}>
      <FormattedMessage defaultMessage="Order New Reader" />
    </Button>
  );
};

export default OrderReader;
